export default __webpack_public_path__ + "static/media/EM0010.34I-18657_-25383_0.04631b83.jpg";